(()=>{
 const root=document.querySelector('[data-quiz-root]');if(!root)return;
 const steps=[...root.querySelectorAll('[data-quiz-step]')],count=root.querySelector('[data-quiz-count]'),bar=root.querySelector('[data-quiz-progress]'),meter=root.querySelector('[role=progressbar]'),footer=root.querySelector('.quiz-footer'),back=root.querySelector('[data-quiz-back]'),next=root.querySelector('[data-quiz-next]'),status=root.querySelector('[data-quiz-status]');
 const storageKey='morgan:equol-quiz:progress:v1',maxAge=30*60*1000;
 let current=0,advanceTimer,scrollFrame;
 const selected=s=>[...s.querySelectorAll('[data-quiz-option][aria-pressed=true]')];
 const remember=()=>{
  try{sessionStorage.setItem(storageKey,JSON.stringify({version:1,savedAt:Date.now(),step:current,scrollY:Math.max(0,window.scrollY),answers:steps.map(s=>selected(s).map(b=>b.dataset.quizOption))}));}catch{}
 };
 const restore=()=>{
  try{
   const saved=JSON.parse(sessionStorage.getItem(storageKey));
   if(!saved||saved.version!==1||!Number.isFinite(saved.savedAt)||Date.now()-saved.savedAt>maxAge||saved.savedAt>Date.now()||!Number.isInteger(saved.step)||saved.step<0||saved.step>=steps.length||!Array.isArray(saved.answers)||saved.answers.length!==steps.length){sessionStorage.removeItem(storageKey);return null;}
   steps.forEach((s,i)=>{
    const choices=Array.isArray(saved.answers[i])?saved.answers[i]:[],buttons=[...s.querySelectorAll('[data-quiz-option]')];
    const valid=buttons.filter(b=>choices.includes(b.dataset.quizOption));
    const kept=s.dataset.kind==='single'?valid.slice(0,1):valid.includes(buttons.at(-1))?[buttons.at(-1)]:valid;
    buttons.forEach(b=>b.setAttribute('aria-pressed',String(kept.includes(b))));
   });
   return saved;
  }catch{return null;}
 };
 const render=(i,focus=true,push=true)=>{
  clearTimeout(advanceTimer);current=Math.max(0,Math.min(i,steps.length-1));
  steps.forEach((s,j)=>s.hidden=j!==current);
  const s=steps[current],single=s.dataset.kind==='single',offer=s.dataset.kind==='offer';
  count.textContent=`${current+1} / ${steps.length}`;bar.style.width=`${current/steps.length*100}%`;meter.setAttribute('aria-valuenow',String(current+1));
  back.hidden=current===0;next.hidden=single||offer;footer.hidden=offer||current===0;footer.dataset.single=String(single);
  next.disabled=s.dataset.kind==='multi'&&selected(s).length===0;
  status.textContent='';
  if(push){const u=new URL(location.href);u.hash=`step-${current+1}`;history.pushState({morganQuizStep:current},'',u);}
  if(focus){s.querySelector('h1')?.focus({preventScroll:true});window.scrollTo({top:0,behavior:'instant'});}
  remember();
 };
 steps.forEach((step,index)=>step.querySelectorAll('[data-quiz-option]').forEach(button=>button.addEventListener('click',()=>{
  if(step.dataset.kind==='single'){
   step.querySelectorAll('[data-quiz-option]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
   remember();advanceTimer=setTimeout(()=>render(index+1),180);
  }else{
   const all=step.querySelector('[data-quiz-option]:last-child');
   if(button===all)step.querySelectorAll('[data-quiz-option]').forEach(b=>{if(b!==all)b.setAttribute('aria-pressed','false');});
   else all?.setAttribute('aria-pressed','false');
   button.setAttribute('aria-pressed',String(button.getAttribute('aria-pressed')!=='true'));
   next.disabled=selected(step).length===0;remember();
  }
 })));
 next.addEventListener('click',()=>{if(next.disabled){status.textContent=root.dataset.choiceError;return;}render(current+1);});
 back.addEventListener('click',()=>render(current-1));
 root.querySelector('[data-quiz-restart]')?.addEventListener('click',()=>{root.querySelectorAll('[data-quiz-option]').forEach(b=>b.setAttribute('aria-pressed','false'));render(0);});
 root.addEventListener('click',event=>{if(event.target.closest('a[href]'))remember();},{capture:true});
 addEventListener('pagehide',remember);
 document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='hidden')remember();});
 addEventListener('scroll',()=>{if(!scrollFrame)scrollFrame=requestAnimationFrame(()=>{scrollFrame=0;remember();});},{passive:true});
 const form=root.querySelector('#MorganQuizCreate'),email=form?.querySelector('[type=email]'),passwordBox=form?.querySelector('[data-quiz-password]'),password=form?.querySelector('[type=password]'),emailNext=form?.querySelector('[data-quiz-email-next]'),register=form?.querySelector('[data-quiz-register]');
 const reveal=()=>{if(!email?.reportValidity())return;passwordBox.hidden=false;password.disabled=false;emailNext.hidden=true;register.hidden=false;password.focus();};
 if(password)password.disabled=true;
 emailNext?.addEventListener('click',reveal);
 form?.addEventListener('submit',event=>{if(passwordBox.hidden){event.preventDefault();reveal();}});
 const fromHash=()=>{const match=location.hash.match(/^#step-(\d+)$/),step=match?Number(match[1])-1:-1;return step>=0&&step<steps.length?step:null;};
 addEventListener('popstate',()=>render(fromHash()??0,true,false));
 const saved=restore(),hashStep=fromHash(),initial=hashStep??saved?.step??0;
 render(initial,false,false);
 if(saved&&hashStep===null){const u=new URL(location.href);u.hash=`step-${initial+1}`;history.replaceState({morganQuizStep:initial},'',u);}
 if(saved&&saved.step===initial&&Number.isFinite(saved.scrollY)){
  const resumeScroll=()=>window.scrollTo({top:Math.max(0,saved.scrollY),behavior:'instant'});
  requestAnimationFrame(resumeScroll);
  if(document.readyState!=='complete')addEventListener('load',resumeScroll,{once:true});
 }
})();
